import { signal } from '@angular/core';
import { SeaSurfaceTemperatureSvgComponent } from './sea-surface-temperature-svg/sea-surface-temperature-legend-svg';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';

export const SEA_SURFACE_TEMPERATURE_LEGEND: TwcLegendParams = {
  title: 'SEA SURFACE TEMPS',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: SeaSurfaceTemperatureSvgComponent },
  legendComponent: TwcLegendComponent
};
